$(function () {
  var lastScrollTop = 0;

  function handleScroll() {
    var scroll = $(window).scrollTop();

    if (scroll > 475) {
      $(".section-header").addClass('section-header-active shopify-section-header-hidden animate');
      if (scroll > lastScrollTop) {
        console.log('11111');
      } else {
        $(".section-header").removeClass('section-header-active shopify-section-header-hidden animate');
        console.log('2222');
      }
    }

    // Update last scroll position
    lastScrollTop = scroll;
  }

  // Run on scroll
  $(window).on("scroll", handleScroll);

  // Run once on load
  handleScroll();
});

$('.video-drawer-image, .home-hero .for-animation, header .for-animation').addClass('is-visible');


$(window).on("scroll", function () {

  
  
    $(".js .temp-index #MainContent img").each(function () {
    var $el = $(this);

    // check if element is in viewport
    var top_of_element = $el.offset().top;
    var bottom_of_element = $el.offset().top + $el.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).height();
    var top_of_screen = $(window).scrollTop();

    if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
      if (!$el.hasClass("is-visible")) {
        $el.addClass("is-visible");
      }
    }
  });

    $("[data-module-reveal]").each(function () {
    var $el = $(this);

    // check if element is in viewport
    var top_of_element = $el.offset().top;
    var bottom_of_element = $el.offset().top + $el.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).height();
    var top_of_screen = $(window).scrollTop();

    if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
      if (!$el.hasClass("is-visible")) {
        $el.addClass("is-visible");
      }
    }
  });
});